// SHARED CODE WITH FRONTEND
import { fieldRegex } from '$/shared/frontend/utils/urls/URLUtils';
import { emailFields } from '$/sections/Home/WebinarEditor/NotificationsEditor/EmailFields';
import { hash53 } from '$/shared/frontend/utils/string';
export * from '$/shared/frontend/utils/string';

export const maxCharsMessage = (maxChars: number): string => {
  return `Please limit to ${maxChars} characters or less.`;
};

const standardizedField = (value: string): string => {
  return value.replace(/[{}\s]/g, '');
};

export const countCharsInMarkdown = (value: string): number => {
  const fieldsUsed = value.match(fieldRegex)?.map((f: string) => standardizedField(f));
  let fieldsLength = 0;
  // count chars when using mention fields
  if (fieldsUsed) {
    fieldsUsed.map((field) => {
      const fieldExist = emailFields.find((f) => field === standardizedField(f.name));
      if (fieldExist) {
        fieldsLength = fieldsLength + fieldExist.maxLength;
      }
    });
  }
  // count chars from markdown string
  const textLength = value
    .replace(/{[^}]+}/g, '')
    .replace(/\n\n\u200b/g, '\n')
    .replace(/\n\n/g, '\n').length;

  return fieldsLength + textLength;
};

export const isValidMaxCharsMarkdown = (maxChars: number, value?: string): boolean => {
  if (!value) return true;
  const hasEndCharacter = value.charAt(value.length - 1) === '\n' ? true : false;
  return countCharsInMarkdown(value) <= (hasEndCharacter ? maxChars + 1 : maxChars);
};


export const hashChatMessageId = (conversationId: string, type: string): string => {
  let id = `${conversationId}:${type}`;
  try {
    id = hash53(id).toString();
  } catch (error) {
    console.error('hashChatMessageId failed', error);
  }
  // adding conversionId in case hash53 has a collision
  return btoa(`${conversationId}:${id}`);
};

export const extractDashboardFilterString = (): string => {
  const url = new URL(window.location.href);
  url.searchParams.delete('aid');
  url.searchParams.delete('id');
  url.searchParams.delete('setId');
  const searchParams = url.search;
  return searchParams.replace(/^\?/, '');
};
